import { useEffect, useState } from 'react'
import { Heading, Text } from 'ui-kit/typography'
import { Actions, Button, Link } from 'ui-kit/actions'
import { Popup } from 'routes/components/Shared'
import classes from './ScenariosCustomBlock.module.scss'

export const ScenariosCustomBlock = () => {
  const [open, setOpen] = useState(false)

  function togglePopupOpen() {
    setOpen(!open)
  }

  const createYourScenario = `${process.env.NEXT_PUBLIC_CONSOLE_URI}/w/0/scenarios`

  return (
    <>
      <div className={classes.wrapper}>
        <Heading as={'h2'} center balance size={'xl'} className={classes.title}>
          Do not see the scenario you need?
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          You can either create one yourself or request a scenario from our
          team.
        </Text>
        <Actions className={classes.actions}>
          <Button
            category={'primary'}
            onClick={togglePopupOpen}
            fitContentBtn
            className={classes.button}
          >
            Request a scenario
          </Button>
          <Link
            href={createYourScenario}
            className={classes.button}
            asPageButton
            target={'_blank'}
            type='secondary'
          >
            Create your own scenario
          </Link>
        </Actions>
      </div>
      <Popup onClose={togglePopupOpen} open={open} className={classes.popup}>
        <TypeFormForm />
      </Popup>
    </>
  )
}

function TypeFormForm() {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = '//embed.typeform.com/next/embed.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return <div data-tf-live='01J474N7BD15VTXAD5A7WHER3V'></div>
}
